/* @flow */

import * as React from 'react';
import { connect } from 'react-redux';
import noop from 'lodash/noop';
import countriesSelector from 'app/selectors/countriesSelector';
import SelectField from 'app/components/form/SelectField';
import { fetchCountries } from 'app/actions/countries';
import t from 'app/utils/translate';

type Props = {
  countries: Array<*>,
  defaultText?: string,
  disabled?: boolean,
  label?: string,
  lightContent?: boolean,
  onChange?: string => void,
  onFetch: () => void,
  value?: number,
};

class CountrySelect extends React.Component<Props> {
  props: Props;

  static defaultProps = {
    defaultText: undefined,
    disabled: false,
    value: undefined,
    label: t('Country'),
    lightContent: false,
    onChange: noop,
  };

  componentDidMount() {
    this.props.onFetch();
  }

  render() {
    const { countries, defaultText, disabled, label, lightContent, onChange, value } = this.props;

    return (
      <SelectField
        defaultText={defaultText}
        disabled={disabled}
        label={label}
        lightContent={lightContent}
        name="country"
        options={countries}
        onChange={onChange}
        value={value}
      />
    );
  }
}

const connector = connect(
  state => ({
    countries: countriesSelector(state),
  }),
  {
    onFetch: fetchCountries,
  },
);

export default connector(CountrySelect);
